<template>
  <div class="coupon">
    <headd :mobile_title="mobile_title"></headd>
    <div class="container">
      <div class="coupon_title hiddex-sm hidden-xs">我的优惠券</div>
      <el-tabs v-model="current" @tab-click="handleClick">
        <el-tab-pane label="全部" name="1"></el-tab-pane>
        <el-tab-pane label="未使用" name="2"></el-tab-pane>
        <el-tab-pane label="已使用" name="3"></el-tab-pane>
        <el-tab-pane label="已过期" name="4"></el-tab-pane>
      </el-tabs>
      <div class="welfare-list" v-if="welfare_list.length > 0">
        <div
          class="welfare-item"
          v-for="(item, index) in welfare_list"
          :key="index"
          :class="[item.showcouponStatus != 'unused' ? 'lose' : '']"
        >
          <div class="item-price">
            <div class="price"><span>￥</span>{{ item.discountValue }}</div>
            <div class="price_tip">{{ item.showminValue }}</div>
          </div>
          <div class="item-info">
            <div class="info-1">
              <div class="tag">{{ item.showcoupontype }}</div>
              {{ item.title }}
            </div>
            <div class="info-2">{{ item.subtitle }}</div>
            <div class="info-3">{{ item.use_info }}</div>
            <div class="info-4">{{ item.showexpiredAt }}</div>
          </div>
          <div class="welfare-button">
            <span v-if="item.showcouponStatus == 'used'">已使用</span>
            <span v-else-if="item.showcouponStatus == 'unused'">未使用</span>
            <span v-else-if="item.showcouponStatus == 'expired'">已过期</span>
          </div>
        </div>
      </div>
      <div class="welfare-list" v-else>
        <div class="no_data">
          <div class="no_icon"></div>
          <div class="no_text">暂无数据</div>
        </div>
      </div>
    </div>
    <foot></foot>
  </div>
</template>

<script>
import headd from "@/components/head";
import foot from "@/components/foot";
import { getmydownloadcoupon } from "../api/api"; //引入api里面定义的方法
export default {
  data() {
    return {
      mobile_title: "我的优惠劵",
      current: "1",
      tabs: ["全部", "未使用", "已使用", "已过期"],
      tatstatus: ["", "unused", "used", "expired"],
      pageindex: 1,
      flag: false,
      usestatus: "",
      welfare_list: []
    };
  },
  mounted() {
    this.getwelfares();
  },
  components: {
    headd,
    foot
  },
  methods: {
    handleClick(tab, event) {
      console.log(tab, event);

      var self = this;
      //console.log("当前选中的项：" + index);
      var index = parseInt(tab.name);
      self.usestatus = self.tatstatus[index - 1];
      self.welfare_list = [];
      self.pageindex = 1;
      self.flag = false;
      //console.log(self.usestatus);
      self.getwelfares();
    },

    async getwelfares() {
      var _slef = this;
      var data = {
        uid: localStorage.getItem("userId"),
        usestatus: _slef.usestatus,
        page: _slef.pageindex,
        limit: 5
      };
      const res = await getmydownloadcoupon(data);
      _slef.welfare_list = _slef.welfare_list.concat(res.data.data.coupons);

      if (res.data.data.coupons.length < 5) {
        _slef.flag = true;
      }
    }
  },
  onShow() {
    this.welfare_list = [];
    this.pageindex = 1;
    (this.flag = false), this.getwelfares();
    this.$logindex();
  },
  onReachBottom() {
    if (!this.flag) {
      this.pageindex++;
      this.getNews();
    }
  },
  onPullDownRefresh() {
    console.log("下拉刷新了");
    this.pageindex = 1;
    this.newsList = [];
    this.flag = false;
    setTimeout(() => {
      this.getNews(() => {
        uni.stopPullDownRefresh();
      });
    }, 1000);
  }
};
</script>

<style lang="less">
.coupon {
  margin: 0 auto;
  flex-direction: column;
  text-align: left;
  @media (max-width: 991px) {
    //width: 6.86rem;
    .container {
      width: 6.86rem;
      padding: 0;
    }
  }
  .coupon_title {
    font-size: 0.26rem;
    margin: 0.32rem 0;
  }

  .welfare-list {
    margin: 0 0 0.32rem 0;
    flex-direction: row;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;

    .welfare-item {
      width: 5.69rem;
      height: 1.26rem;
      background: url(../../../static/index/welfare/welfare-item-bg2.png)
        no-repeat;
      background-size: 100%;
      flex-direction: row;
      align-items: center;
      margin-bottom: 0.3rem;
      padding: 0;
      display: flex;
      @media (max-width: 991px) {
        width: 100%;
        height: 1.48rem;
      }

      .item-price {
        width: 1.85rem;
        color: #ff545a;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        text-align: center;
        @media (max-width: 991px) {
          width: 2.15rem;
        }

        .price {
          font-size: 0.4rem;
          line-height: 0.5rem;
          position: relative;

          span {
            font-size: 0.26rem;
            line-height: 0.5rem;
            vertical-align: bottom;
            width: 0.3rem;
          }
        }

        .price_tip {
          margin-top: 0.1rem;
          font-size: 0.16rem;
          color: #cd7420;
        }
      }

      .item-info {
        flex-direction: column;
        justify-content: center;
        text-align: left;
        color: #cd7420;
        width: 2.2rem;
        @media (max-width: 991px) {
          width: 2.8rem;
          text-align: left;
        }

        .info-1 {
          line-height: 0.28rem;
          font-size: 0.2rem;
          display: flex;
          align-items: center;

          .tag {
            width: 0.66rem;
            height: 0.22rem;
            line-height: 0.22rem;
            text-align: center;
            align-items: center;
            justify-content: center;
            background: #ff545a;
            border-radius: 0.11rem;
            font-size: 0.16rem;

            color: #ffffff;
          }
        }

        .info-2 {
          font-size: 0.18rem;
          line-height: 0.25rem;
          letter-spacing: 0.03rem;
        }

        .info-3 {
          line-height: 0.17rem;
          font-size: 0.12rem;

          color: #cd7420;
        }

        .info-4 {
          line-height: 0.17rem;
          font-size: 0.12rem;

          color: #cd7420;
        }
      }

      .welfare-button {
        margin-left: 0.4rem;
        width: 0.85rem;
        height: 0.85rem;
        background: url(../../../static/index/welfare/welfare-item-button.png)
          no-repeat;
        background-size: 100%;
        color: #ffffff;
        text-align: center;
        align-items: center;
        justify-content: center;
        font-size: 0.24rem;
        font-weight: bolder;
        display: flex;
        @media (max-width: 991px) {
          margin-left: 0.5rem;
        }
      }
    }

    .lose {
      -webkit-filter: grayscale(100%);
      -moz-filter: grayscale(100%);
      filter: grayscale(100%);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/coupon/coupon.vue